import { navSidebar } from '@/lib/data/site/navSidebar';
import type { NavLink } from '@/lib/types/navLink';

function normalizeNavPath(href?: string): string | null {
  if (!href || href === '#') {
    return null;
  }

  const trimmed = href.replace(/^\/+|\/+$/g, '');
  return trimmed || null;
}

function collectFromLinks(links: NavLink[], paths: Set<string>): void {
  for (const link of links) {
    const path = normalizeNavPath(link.href);
    if (path) {
      paths.add(path);
    }

    if (link.children) {
      for (const group of link.children) {
        const nestedLinks = Array.isArray(group) ? group : [group];
        collectFromLinks(nestedLinks, paths);
      }
    }
  }
}

/** Storefront category paths derived from the sidebar nav (source of truth for PDP breadcrumbs). */
export function collectNavCategoryPaths(): Set<string> {
  const paths = new Set<string>();
  collectFromLinks(navSidebar, paths);
  return paths;
}
